import React, { useState, useCallback, useEffect } from "react";
import { Image } from '@fluentui/react';
import {AppMenu} from "./AppMenu";


interface InventoryManagementProps {}

interface InventoryManagementState {}

const InventoryManagement: React.FC<InventoryManagementProps> = ({}) => {           
    const [pageState, setPageState] = useState<InventoryManagementState>(() => {});

    return(
        <>
                                    <div style={{width: "100%", textAlign: "left"}}>
                                        <AppMenu/>
                                    </div>
                                    <div key={'IM1'} style={{ 
                                    flex: '1 1 calc(100% - 40px)',
                                    minWidth: '250px',
                                    height: '510px',
                                    background: 'white',
                                    borderRadius: '8px',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                    overflow: 'hidden'
                                  }}>
                                    <div style={{ 
                                      padding: '15px', 
                                      borderBottom: '0px solid #e1e1e1',
                                      background: '#ffffff',
                                      fontWeight: 600,
                                      color: '#323130'
                                    }}>
                                      Inventory Management
                                    </div>
                                    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                                       <div className="card-grey">         
                                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                                <div style={{  gap: '8px', letterSpacing: '0.02em', fontSize: '0.95rem' }}>eSDG's integrated service partnerships combined with AI based Inventory Management facilitates accurate & timely stock movements, supports different types of inventories, transportation & logistics management and shipment tracking.</div>
                                                <Image src="inventorymanagement.png" alt="Inventory Management" style={{ width: '450px', height: '350px', objectFit: 'scale-down' }} />
                                            </div>
                                            <div></div>
                                      </div>
                                    </div>
                                  </div>
                                </>
    );
}

export default InventoryManagement; 
